import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import ChapterToggler from "../../../Components/ChapterToggler";

const CreateExtra = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Extras Verwalten</Text>

                <Text type="itemtext">
                    Extras sind Zusätze, welche sich Kunden optional zu Produkten wünschen können.
                </Text>

                <SmallImage src={"instructions/extra-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Neues Extra erstellen</Text>
                    <Text type="title">2. Alle Extras</Text>
                    <Text type="title">3. Editieren / Löschen</Text>
                </div>

                {/* 1. Neues Extra erstellen */}
                <ChapterToggler title="1. Neues Extra erstellen">
                    <Text type="itemtext">
                        Durch das Drücken auf diesen Knopf öffnet sich folgendes Formular:
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/extra-create.png"}
                        smallSize="w-1/3"
                        subtitle="Extra Formular"
                    />

                    <br />

                    <Text type="itemtext">
                        Folgende Eigenschaften können definiert werden:
                    </Text>

                    <Text type="itemtext">
                        <b>Name:</b> Name des Extras
                    </Text>
                    <Text type="itemtext">
                        <b>Preis:</b> Preis des Extras
                    </Text>
                </ChapterToggler>

                {/* 2. Alle Extras */}
                <ChapterToggler title="2. Alle Extras">
                    <Text type="itemtext">
                        Hier werden alle vorhandenen Extras aufgelistet.
                    </Text>
                </ChapterToggler>

                {/* 3. Editieren / Löschen */}
                <ChapterToggler title="3. Editieren / Löschen">
                    <Text type="itemtext">
                        Diese Knöpfe erlauben es, Extras zu bearbeiten oder zu löschen.
                        Beim Editieren öffnet sich dasselbe Formular wie beim Erstellen.
                    </Text>
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default CreateExtra;
